import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    gpsUserConsole: translate({ id: 'app.header.gpsUserConsole' }),
  }))

  return api
}
